<app-header></app-header>
<!-- <app-top-header></app-top-header> -->
<div class="app-fan-landing-page">
    <!-- <SECTION1> -->
    <div class="banner">
        <div class="container pt-110">
            <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="30px grid" fxLayoutGap.xs="0px grid" class="w-100">
                <div fxFlex="60%" fxFlex.xs="100%">
                   <p class="txt-pink fs-43">STREAM EXCLUSIVE<br>EXPERIENCES<br>FROM AROUND<br>THE WORLD </p>
                   <p class="txt-white fs-19">Subscribe to any channel of <br> your choice</p>
                </div>
                <div fxFlex="40%" fxFlex.xs="100%">
                    <div class="bg-box">
                        <div fxLayout fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="10px"
                            fxLayoutGap.xs="0">
                            <form [formGroup]="signUpForm" fxLayoutAlign="center center">
                                <div fxLayout="row wrap" class="profile_basic" fxFlex="100%" fxLayoutGap="1px"
                                    fxLayoutAlign="center end">
                                    <div fxFlex="100%" fxFlex.xs="100%" class="pb-5">
                                        <mat-form-field class="w-100">
                                            <mat-label>Email</mat-label>
                                            <input name="email" formControlName="email" required maxlength="255"
                                                matInput>
                                            <mat-error *ngIf="signUpForm.get('email').hasError('required')">
                                                Please enter email
                                            </mat-error>
                                            <mat-error *ngIf="signUpForm.get('email').hasError('email')">
                                                Please enter valid email
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="100%" fxFlex.xs="100%" class="pb-5">
                                        <mat-form-field class="w-100">
                                            <mat-label>First Name</mat-label>
                                            <input matInput name="firstName" formControlName="firstName"
                                                required maxlength="35" allowValues isInputType="onlyChar">
                                            <mat-error *ngIf="signUpForm.get('firstName').hasError('required')">
                                                Please enter first Name
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="100%" fxFlex.xs="100%" class="pb-5">
                                        <mat-form-field class="w-100">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput name="username" formControlName="lastName" required
                                                maxlength="35" allowValues isInputType="onlyChar">
                                            <mat-error *ngIf="signUpForm.get('lastName').hasError('required')">
                                                Please enter last name
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="100%" fxFlex.xs="100%">
                                        <mat-form-field class="w-100 country-flag-txt">
                                            <mat-label>Contact Number</mat-label>
                                            <input matInput countryFlagPhone allowValues isInputType="phone"
                                                formControlName="phone_number" required>
                                            <mat-error
                                                *ngIf="signUpForm.get('phone_number').hasError('required')">
                                                Please enter phone number
                                            </mat-error>
                                            <mat-error *ngIf="!signUpForm.get('phone_number').hasError('required') && 
                                signUpForm.get('phone_number').hasError('isInvalid')">
                                                Please enter valid phone number
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div fxFlex="100%" fxFlex.xs="100%" class="mt-4">
                                        <button mat-flat-button class="yellow-btn ff" (click)="goToSignUp()">
                                            START FREE TRIAL
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <!-- <SECTION2> -->
    <div class="banner1">
        <div class="p-10p">
        <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="40px grid" fxLayoutGap.xs="0px grid" class="w-100" fxLayoutAlign="center center">
            <div fxFlex="50%" fxFlex.xs="100%">
                <img src="assets/landing-new-img1.jpg" style="width: 100%;">
            </div>
            <div fxFlex="50%" fxFlex.xs="100%">
                <div class="text-left">
                    <p class="txt-black fs-43 mt-4">LIVE EXPERIENCES<br> IN YOUR <br> LIVING ROOM</p>
                    <p class="para">Be it Video On Demand or Pay Per View, your<br>favorite artists are closer than you think.<br>Stream exclusive experiences and join the celebration.</p>
                    <button class="btn-transparent mt-3" [routerLink] = "['/']"  fragment="liveevents">LIVE EVENTS</button><span><i
                            class="fa fa-arrow-right icon-color" aria-hidden="true"></i></span>
                        </div>
            </div>
        </div>
    </div>
    </div>
     <!-- <SECTION3> -->
    <div class="bg-black">
        <div class="container">
        <div class="txt-white-title fs-43">STREAMING INFINITE POSSIBILITIES</div>
        <div fxLayout="row wrap" fxLayoutAlign="center center"
        fxLayoutGap="10px grid" fxLayoutGap.xs="0" fxLayoutGap.sm="0px" class="w-100">

        <div fxFlex="20%" fxFlex.sm="30%" fxFlex.xs="50%">
            <div class="text-center">

                <img src="assets/icon1.png" class="icon-s-80">
                <p class="icon-txt-title">Live<br>Concerts</p>
            </div>
        </div>
        <div fxFlex="20%" fxFlex.sm="30%" fxFlex.xs="50%">
            <div class="text-center">

                <img src="assets/icon2.png" class="icon-s-80">
                <p class="icon-txt-title">Comedy</p>
            </div>
        </div>
        <div fxFlex="20%" fxFlex.sm="30%" fxFlex.xs="50%">
            <div class="text-center">

                <img src="assets/icon7.png" class="icon-s-80">
                <p class="icon-txt-title">Festivals</p>
            </div>
        </div>
        <div fxFlex="20%" fxFlex.sm="30%" fxFlex.xs="50%">
            <div class="text-center">

                <img src="assets/icon6.png" class="icon-s-80">
                <p class="icon-txt-title">Special<br>Events</p>
            </div>
        </div>
        <div fxFlex="20%" fxFlex.sm="30%" fxFlex.xs="50%">
            <div class="text-center">

                <img src="assets/icon5.png" class="icon-s-80">
                <p class="icon-txt-title">Drama &<br>Theatre</p>
            </div>
        </div>
           
        </div>
    </div>
    </div>
    <!-- <SECTION4> -->
    <div class="banner2">
        <div class="container">
            <div class="text-left">
                <p class="txt-yellow fs-43">BACKSTAGE <br> MEET & GREETS,<br>NOW ON YOUR SCREENS</p>
                <p class="para">Engage with your favorite creators in<br> real-time with live chats and access<br>exclusive Meet & Greets.</p>
                <button class="btn-transparent mt-3" [routerLink] = "['/']"  fragment="trendingchannels">TRENDING CHANNELS</button><span><i
                        class="fa fa-arrow-right icon-color" aria-hidden="true"></i></span>
               
            </div>
        </div>
    </div>
    <!-- SECTION5 -->
    <div class="bg-yellow">
       
            <div fxLayout="row wrap" fxLayout.xs="column" class="w-100" fxLayoutAlign="center center" fxLayoutAlign.xs="start start">
                <div fxFlex="50%" fxFlex.xs="100%">
                    <img src="assets/landing-new-img2.jpg" style="width: 100%;">
                </div>
                <div fxFlex="50%" fxFlex.xs="100%">
                    <div class="ml-30">
                    <div class="text-left">
                        <p class="txt-black fs-43 mt-4">SUPPORT THE <br>CREATOR <br>COMMUNITY</p>
                        <p class="para">With every experience hosted, you can show<br>your appreciation by tipping artists, and<br> donate to creator backed charities.</p>
                        <button class="btn-transparent mt-3 mb-20" routerLink="/signup"><span class="sign-up-class">SIGN UP NOW</span></button><span><i
                                class="fa fa-arrow-right icon-color" aria-hidden="true"></i></span>
                       
                    </div>
                </div>
                </div>
            </div>
       
    </div>

</div>
<app-website-footer></app-website-footer>
<!-- <app-footer></app-footer> -->